import {
    CATEGORY,
    CATEGORY_SUCCESS,
    CATEGORY_ERROR,
    ADD_CATEGORY,
    ADD_CATEGORY_SUCCESS,
    ADD_CATEGORY_ERROR,
    UPDATE_CATEGORY,
    UPDATE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_ERROR,
    DELETE_CATEGORY,
    DELETE_CATEGORY_ERROR,
    DELETE_CATEGORY_SUCCESS,
    CATEGORY_ICONS,
    CATEGORY_ICONS_SUCCESS,
    CATEGORY_ICONS_ERROR,
    ICONS,
    ICONS_ERROR,
    ICONS_SUCCESS,
} from "../constants/categoryConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function categoryReducer(state = initialState, action) {
    switch (action.type) {
        case CATEGORY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'CATEGORY',
                'loadingMessage': 'THE CATEGORIES ARE BEING LOADED',
                'type': action.type

            });
        case CATEGORY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'categoryData': '',
                'type': action.type
            });
        case CATEGORY_SUCCESS:


            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'categoryData': action.data,
                'type': action.type

            });
        case ADD_CATEGORY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'CATEGORY',
                'loadingMessage': 'THE CATEGORY IS BEING SAVED',
                'type': action.type
            });
        case ADD_CATEGORY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_CATEGORY_SUCCESS:
            let addCategoryData = state.categoryData ? [...state.categoryData] : []
            addCategoryData.push(action.data);

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'categoryData': addCategoryData,
                'type': action.type
            });
        case UPDATE_CATEGORY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'CATEGORY',
                'loadingMessage': 'THE CATEGORY IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_CATEGORY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_CATEGORY_SUCCESS:

            let updCategoryData = state.categoryData ? state.categoryData : []

            updCategoryData = updCategoryData.map((item) => { return item._id === action.data._id ? action.data : item });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'categoryData': updCategoryData,
                'type': action.type
            });
        case DELETE_CATEGORY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'CATEGORY',
                'loadingMessage': 'THE CATEGORY IS BEING DELETED',
                'type': action.type
            });
        case DELETE_CATEGORY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_CATEGORY_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'categoryData': (state.categoryData) ? state.categoryData.filter(item => item._id !== action.data) : [],
                'type': action.type
            });
        //ICONS
        case CATEGORY_ICONS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'CATEGORY',
                'loadingMessage': 'THE CATEGORIES ICONS ARE BEING LOADED',
                'type': action.type
            });
        case CATEGORY_ICONS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case CATEGORY_ICONS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'IconsData': action.data,
                'type': action.type
            });

        //Icons with tags

        case ICONS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ICONS',
                'loadingMessage': 'THE ICONS ARE BEING LOADED',
                'type': action.type
            });
        case ICONS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ICONS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'IconsData': action.data,
                'type': action.type
            });
        default:
            return state;
    }
};

export default categoryReducer